import PropTypes from 'prop-types';
import { useTheme } from '@mui/material';

import { DatePickerBase } from '@baseComponents/DateTimePicker';

const VIEWS = ['year'];

const defaultMaxDate = new Date(
    new Date().getFullYear(),
    0
);

const YearPicker = ({
    name = 'year-picker',
    views = VIEWS,
    openTo = 'year',
    maxDate = defaultMaxDate,
    inputFormat = 'YYYY',
    ...props
}) => {
    const { spacing } = useTheme();

    return (
        <DatePickerBase
            name={name}
            views={views}
            openTo={openTo}
            maxDate={maxDate}
            inputFormat={inputFormat}
            {...props}
            styles={{ input: { height: spacing(4.5) } }}
        />
    );
};

// Optional: Only keep propTypes you actually need
YearPicker.propTypes = {
    name: PropTypes.string,
};

export { YearPicker as default, YearPicker };
